import React, { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from './firebase';
import Landing from './Landing';
import FamilyNotFound from './FamilyNotFound';
import Auth from './Auth';
import FamilyApp from './FamilyApp';
import { rememberFamily, lastMemberFor } from './storage';

// /f/{familyCode}[/...] -> normalized code, otherwise null
export function parseFamilyCode(pathname) {
  const m = pathname.match(/^\/f\/([^/]+)\/?/);
  if (!m) return null;
  try {
    return decodeURIComponent(m[1]).trim().toLowerCase();
  } catch {
    return '';
  }
}

function Family({ code }) {
  const [family, setFamily] = useState(undefined); // undefined = loading, null = missing
  const [gifts, setGifts] = useState({});
  const [profiles, setProfiles] = useState({});
  const [currentUser, setCurrentUser] = useState('');
  const lastMember = lastMemberFor(code);

  // All reads are scoped to families/{code}; real-time via onSnapshot.
  useEffect(() => {
    const base = ['families', code];
    const unsubs = [
      onSnapshot(doc(db, ...base), (d) => setFamily(d.exists() ? d.data() : null), () => setFamily(null)),
      onSnapshot(doc(db, ...base, 'data', 'gifts'), (d) => setGifts(d.exists() ? d.data().gifts || {} : {})),
      onSnapshot(doc(db, ...base, 'data', 'profiles'), (d) => setProfiles(d.exists() ? d.data().profiles || {} : {}))
    ];
    return () => unsubs.forEach(u => u());
  }, [code]);

  if (family === undefined) return null;
  if (family === null || !Array.isArray(family.members)) return <FamilyNotFound />;

  const login = (member) => {
    rememberFamily(code, { member });
    setCurrentUser(member);
  };

  if (!currentUser) {
    return <Auth code={code} family={family} lastMember={lastMember} onLogin={login} />;
  }
  return (
    <FamilyApp
      code={code}
      family={family}
      gifts={gifts}
      profiles={profiles}
      currentUser={currentUser}
      onLogout={() => setCurrentUser('')}
    />
  );
}

export default function App() {
  const code = parseFamilyCode(window.location.pathname);
  if (code === null) return <Landing />;
  if (!code) return <FamilyNotFound />;
  return <Family key={code} code={code} />;
}
